<template>
  <el-container
    class="container-editor is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div
          style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;"
        >
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item :to="{ path: '/message' }">聯絡訊息</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main>
        <table class="message-info-table">
          <tr>
            <th>大名</th>
            <td>{{message.Name}}</td>
          </tr>
          <tr>
            <th>Email</th>
            <td>{{message.Email}}</td>
          </tr>
          <tr>
            <th>電話</th>
            <td>{{message.Phone}}</td>
          </tr>
          <tr>
            <th>內容</th>
            <td>{{message.Content}}</td>
          </tr>
        </table>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'

import MixinFilters from '@/utils/filters/filter-mixin.vue'
export default {
  mixins: [MixinFilters],
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {}
  },
  computed: {
    title () {
      return '訊息'
    },
    message () {
      let id = parseInt(this.$route.params.id)
      if (id && id > 0) {
        return this.$store.state.message.list.find(o => o.ID === id)
      }
      return {}
    }
  },
  methods: {},
  created () {
    // inti table data
  }
}
</script>

<style>
.message-info-table {
  text-align: left;
}
.message-info-table th,
td {
  padding: 4px 0;
}
.message-info-table th {
  padding-right: 12px;
}
</style>
